import { combineReducers } from 'redux';
import { DeviceDataReducer } from './devices';
import layoutReducer from './layout';
import { UserReducer } from './user';
import { UsersReducer } from './users';

const rootReducer = combineReducers({
  user: UserReducer,
  users: UsersReducer,
  devices: DeviceDataReducer,
  layout: layoutReducer,
});

export default rootReducer;
